import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CourseService } from 'src/app/core/services/course.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';

@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.css']
})
export class CommonDialogComponent implements OnInit {
  courseData: any;
  @Input() cta: any = null;
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<CommonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public courseService:CourseService
  ) { }

  ngOnInit(): void {
    console.log('common dialog Data', this.data);
  
  }

  viewCourse(){
    this.dialogRef.close();
    if(!this.courseData?.isRecordedCourse){
      if(this.data.dataType == 'detail' || this.data.dataType == 'batch'){
        this.router.navigate(['/mycourse', this.data.id], {queryParams: {enrolled: 'course'}})
      } else {
        this.router.navigate(['/mycourse', this.data.id],{queryParams: {enrolled: 'course'}})
      }
    }else{
      let state= {
        data:this.cta?.data,
        filter:this.cta?.filter,
        
      }
      this.courseService.courseData.next(state); 
      this.router.navigate([`/mycourse/${this.cta.data.id}`], {state,queryParams: {enrolled: 'course'}})

    }
    // [routerLink]="['/mycourse', data.id]"
  }

  

}
